import {InterviewGuideTabProps} from 'iq-interview_guides/types';
import {PracticeWithAICta} from 'iq-interview_guides/components/practice_with_ai_cta';
import {StagesTimeline} from 'iq-interview_process/components/stages_timeline';

export const ProcessOverviewTab: React.FC<InterviewGuideTabProps> = ({interviewGuide}) => {
  return (
    <div>
      <h2 className='text-xl font-bold text-iq-black mb-1'>Interview process overview</h2>
      <p className='text-sm text-iq-grey-medium mb-6'>
        Synthesized from candidate reports. Individual experiences may vary.
      </p>

      <PracticeWithAICta guideSlug={interviewGuide.slug} className='mb-6' />

      <StagesTimeline stages={interviewGuide.data.interview_process} />
    </div>
  );
};
